import { gql } from '@apollo/client';

const ScheduledShipmentInfoShared = gql`
  fragment ScheduledShipmentInfoShared on ScheduledShipment {
    id
    expectedShippedAt
    shippedAt
    broughtForward
    consumed
    createdAt
    updatedAt
    patient {
      id
      firstName
      lastName
    }
    productionOrder {
      id
      hexCode
      customerState
      sendToClinic
      address
      productionOrderItems {
        id
        name
        trackingNumber
        quantity
        trackingUrl
        deliveredAt
        eta
        labelUrl
        shippingCarrier {
          id
          name
        }
      }
    }
  }
`;

export default ScheduledShipmentInfoShared;
